import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "flex items-center justify-end gap-6 h-[56px] px-4 pb-2" }
const _hoisted_2 = { class: "support-dropdwon" }
const _hoisted_3 = {
  href: "https://docs.google.com/document/d/1sL8tQO7dfQXkDkKys96_4Acfik1X-JqyuTbcmhP1bNg/edit?usp=sharing",
  target: "_blank"
}
const _hoisted_4 = {
  to: "#",
  class: "head-example"
}
const _hoisted_5 = { class: "w-36 bg-white shadow-xl" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-sm text-gray-700" }
const _hoisted_9 = { class: "flex items-center space-x-2 cursor-pointer" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "user-dropdwon" }
const _hoisted_12 = { class: "user-dropdwon__info" }
const _hoisted_13 = { class: "user-dropdwon__links" }
const _hoisted_14 = {
  to: "#",
  class: "mb-2"
}

import { useAuth0 } from '@auth0/auth0-vue'
import { useStore } from '@/store'
import { useRouter } from 'vue-router'
import { LogoutOutlined } from '@ant-design/icons-vue'
import { computed, reactive } from 'vue'
import ModalWindow from '@/components/ModalWindow.vue'
import UserProfile from '@/components/UserProfile.vue'
import { useI18n } from 'vue-i18n'

const avatar = '/img/avatar/chat-auth.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'info',
  setup(__props) {

const { t, locale } = useI18n({ useScope: 'global' })
const store = useStore()
const { logout } = useAuth0()

const langs = [
  { code: 'en', name: 'English',    flag: '/img/flags/en.png' },
  { code: 'es', name: 'Español',    flag: '/img/flags/es.png' },
  { code: 'ee', name: 'Eesti keel', flag: '/img/flags/ee.png' },
  { code: 'ka', name: 'ქართული',    flag: '/img/flags/ka.png' },
  { code: 'ru', name: 'По-русски',  flag: '/img/flags/ru.png' },
  { code: 'uk', name: 'Українська', flag: '/img/flags/uk.png' },
  { code: 'de', name: 'Deutsche',   flag: '/img/flags/de.png' },
  { code: 'ar', name: 'بالعربية',   flag: '/img/flags/ar.png' },
  { code: 'li', name: 'Lietuvių',   flag: '/img/flags/li.png' },
]

const flag = reactive({ code: (locale.value || 'en').split('-')[0] })
const currentFlag = computed(() => `/img/flags/${flag.code || 'en'}.png`)

const currentUser = computed(() => store.state.currentUser || { name: '' })
const currentInstitution = computed(() => store.getters.activeInstitutionName)
const userProfile = reactive({ show: false })

function SignOut() {
  localStorage.removeItem('apollo-token')
  logout()
}

function onFlagChangeHandle(code: string) {
  flag.code = code
  locale.value = code
}


return (_ctx: any,_cache: any) => {
  const _component_sdHeading = _resolveComponent("sdHeading")!
  const _component_sdFeatherIcons = _resolveComponent("sdFeatherIcons")!
  const _component_sdPopover = _resolveComponent("sdPopover")!
  const _component_sdDropdown = _resolveComponent("sdDropdown")!
  const _component_UserDropDwon = _resolveComponent("UserDropDwon")!
  const _component_a_avatar = _resolveComponent("a-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_sdPopover, {
      placement: "bottomLeft",
      action: "click"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", null, [
            _createVNode(_component_sdHeading, { as: "h5" }, {
              default: _withCtx(() => [
                _createTextVNode("Documentation")
              ]),
              _: 1
            }),
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_3, _toDisplayString(_unref(t)('menu.userGuide')), 1)
            ])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("a", _hoisted_4, [
          _createVNode(_component_sdFeatherIcons, {
            type: "help-circle",
            size: "20"
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_sdDropdown, {
      placement: "bottomRight",
      action: ['click']
    }, {
      overlay: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(langs, (lang) => {
            return _createElementVNode("div", {
              key: lang.code,
              onClick: ($event: any) => (onFlagChangeHandle(lang.code)),
              class: "flex items-center px-3 py-1.5 hover:bg-gray-100 cursor-pointer"
            }, [
              _createElementVNode("img", {
                src: lang.flag,
                alt: "",
                class: "w-8 h-5 mr-2"
              }, null, 8, _hoisted_7),
              _createElementVNode("span", _hoisted_8, _toDisplayString(lang.name), 1)
            ], 8, _hoisted_6)
          }), 64))
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("a", _hoisted_9, [
          _createElementVNode("img", {
            src: currentFlag.value,
            alt: "flag",
            class: "w-8 h-5"
          }, null, 8, _hoisted_10)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_sdPopover, {
      placement: "bottomRight",
      action: "click",
      class: _normalizeClass(_ctx.rtl ? 'ant-popover-rtl' : '')
    }, {
      content: _withCtx(() => [
        _createVNode(_component_UserDropDwon, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("figure", _hoisted_12, [
                _createElementVNode("img", {
                  src: avatar,
                  alt: ""
                }),
                _createElementVNode("figcaption", null, [
                  _createVNode(_component_sdHeading, { as: "h5" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(currentUser.value.name), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", null, _toDisplayString(currentInstitution.value), 1)
                ])
              ]),
              _createElementVNode("ul", _hoisted_13, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (userProfile.show = !userProfile.show)),
                    class: "!flex gap-1 items-center ml-3",
                    to: "#"
                  }, [
                    _createVNode(_component_sdFeatherIcons, { type: "settings" }),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('general.settings')), 1)
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    onClick: SignOut,
                    class: "!flex gap-1 justify-start text-left items-center",
                    to: "#"
                  }, [
                    _createVNode(_unref(LogoutOutlined)),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('general.signOut')), 1)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("a", _hoisted_14, [
          _createVNode(_component_a_avatar, { src: "https://cdn0.iconfinder.com/data/icons/user-pictures/100/matureman1-512.png" })
        ])
      ]),
      _: 1
    }, 8, ["class"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (userProfile.show)
        ? (_openBlock(), _createBlock(ModalWindow, {
            key: 0,
            onClose: _cache[2] || (_cache[2] = (type) => (userProfile.show = type))
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('user.accountSettings')), 1)
            ]),
            default: _withCtx(() => [
              (currentUser.value && currentUser.value.id)
                ? (_openBlock(), _createBlock(UserProfile, {
                    key: 0,
                    "user-id": currentUser.value.id,
                    onClose: _cache[1] || (_cache[1] = (type) => (userProfile.show = !type))
                  }, null, 8, ["user-id"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})